import {useEffect} from 'react';
import {sendYandexMetrikaEcommerceEvent} from "../analytics";
import {buildAnalyticsCategory} from "../helpers/analyticsHelpers";

/**
 * Sends an event for booking
 * @param {object} order - Order object
 * @param {string} productType - Product type ('sport'/'school'/'travel'/'certificate'/'abonement')
 */

const useSendBookingEvent = (order, productType) => {
    useEffect(() => {
        if (!order?.id) return;

        const productData = getProductData(order, productType);

        const totalPaid = +order?.totalValue

        sendYandexMetrikaEcommerceEvent('start_order', {
            products: [
                {
                    id: productData.id,
                    name: productData.name,
                    price: totalPaid,
                    brand: "Сила ветра",
                    category: productData.category,
                    variant: productType === 'abonement' ? productData.name : undefined,
                    list: "Booking",
                    position: 1,
                    quantity: order?.paidForLength || 1,
                }
            ],
            total: totalPaid,
            orderId: order.id,
        });

    }, [order?.id]);
};

const getProductData = (order, productType) => {
    const category = buildAnalyticsCategory(order);
    const isSchoolPractice = order?.product_type === "practice"

    const dataMap = {
        sport: {
            id: order?.slot?.web_url_products,
            name: order?.slot?.name,
            price: order?.slot?.price_value,
            category,
        },
        school: {
            id: isSchoolPractice ? order?.practice?.web_url_products :  order?.groupId?.web_url_products,
            name: isSchoolPractice ? order?.practice?.name : order?.groupId?.name,
            price: order?.groupId?.price,
            category,
        },
        travel: {
            id: order?.arrival?.web_url_products,
            name: order?.arrival?.name,
            price: order?.arrival?.price_value,
            category,
        },
        certificate: {
            id: 'certificate',
            name: order?.name,
            price: order?.totalValue,
            category,
        },
        abonement: {
            id: 'abonement',
            name: 'Abonement',
            price: order?.totalValue,
            category,
        }
    };

    return dataMap[productType];
};

export default useSendBookingEvent;